import * as React from 'react';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import Select from 'react-select';
import ReactHtmlParser from 'react-html-parser';
import fetch from 'cross-fetch';
import { connect } from 'react-redux';
import {
    IDEAL_ISSUER_LIST_URL,
    IDEAL_TRANSACTIONREQUEST_URL,
    IDEAL_GETIDEALSERVICETRANSACTION_URL
} from '../../constants/Constants';
import { Redirect } from 'react-router-dom';
import { getAllUrlParams } from '../../../jslibs/urlparams';
import * as actions from '../../actions/FormActions';
import { getResourceString } from '../../kentico/resource-strings';

export interface MijnFNVIdealBankSelectorProps {
    intro: string;
    title: string;
    bankSelectorLabel: string;
    selectBankPlaceholder: string;
    paymentButtonTitle: string;
    lidnummer: string;

    showErrorOnApiError: any;
}

const mapStateToProps = (state: any) => {
    return {
        lidnummer: state.user.lidnummer
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        showErrorOnApiError: error => {
            dispatch(actions.showErrorOnApiError(error));
        }
    };
};

export interface MijnFNVIdealBankSelectorState {
    selectedBank: number;
    issuerList: any[];
    redirectUrl: string;
    doRedirect: boolean;
    customerTransactionDescription: string;
    totalAmount: number;
    isTransactionNotFound: boolean;
    isLoading: boolean;
    isSendingData: boolean;

    hasError: boolean;
}

export interface MijnFNVIDealTransactionPostData {
    IssuerId: string;
    Amount: number;
    Purchase: string;
    Description: string;
    EntranceCode: string;
    MerchantReturnUrl: string;
}

const styles = {
    clearIndicator: () => undefined,
    container: () => undefined,
    control: () => undefined,
    dropdownIndicator: () => undefined,
    groupHeading: () => undefined,
    indicatorsContainer: () => undefined,
    indicatorSeparator: () => undefined,
    input: () => undefined,
    loadingIndicator: () => undefined,
    loadingMessage: () => undefined,
    menu: () => undefined,
    menuList: () => undefined,
    multiValue: () => undefined,
    multiValueLabel: () => undefined,
    multiValueRemove: () => undefined,
    noOptionsMessage: () => undefined,
    option: () => undefined,
    placeholder: () => undefined,
    singleValue: () => undefined,
    valueContainer: () => undefined
};

export class MijnFNVIdealBankSelectorContained extends React.Component<
    MijnFNVIdealBankSelectorProps,
    MijnFNVIdealBankSelectorState
> {
    state = {
        selectedBank: 0,
        issuerList: [],
        redirectUrl: '',
        doRedirect: false,
        customerTransactionDescription: '',
        totalAmount: 0.0,
        isTransactionNotFound: false,
        isLoading: true,
        hasError: false,
        isSendingData: false
    };

    componentDidMount() {
        let urlParams = getAllUrlParams(this.context.search);

        if (!urlParams || !urlParams.transactionGuid) {
            return;
        }

        fetch(
            IDEAL_GETIDEALSERVICETRANSACTION_URL + '?transactionGuid=' + urlParams.transactionGuid
        )
            .then(response => {
                if (response.status == 404) {
                    this.setState({
                        isTransactionNotFound: true,
                        isLoading: false
                    });
                    return {};
                }

                if (response.status >= 300) {
                    return { error: true, reply: response.json() };
                } else {
                    return response.json();
                }
            })
            .then(json => {
                if (!!(json as any).error) {
                    this.props.showErrorOnApiError();
                    this.setState({ hasError: true });
                    return;
                }

                this.setState({
                    customerTransactionDescription: (json as any).CustomerDescription,
                    totalAmount: (json as any).Amount,
                    isLoading: false
                });
            });

        fetch(IDEAL_ISSUER_LIST_URL)
            .then(response => {
                if (response.status >= 300) {
                    return { error: true };
                } else {
                    return response.json();
                }
            })
            .then(json => {
                if (!!(json as any).error) {
                    this.props.showErrorOnApiError();
                    this.setState({ hasError: true });
                    return;
                }

                if (!json['<Directory>k__BackingField']) {
                    return;
                }

                if (!json['<Directory>k__BackingField']['<Countries>k__BackingField']) {
                    return;
                }

                if (json['<Directory>k__BackingField']['<Countries>k__BackingField'].length > 0) {
                    this.setState({
                        issuerList: json['<Directory>k__BackingField'][
                            '<Countries>k__BackingField'
                        ][0]['<Issuers>k__BackingField'].map((item, index) => {
                            return {
                                value: item['<Id>k__BackingField'],
                                label: item['<Name>k__BackingField']
                            };
                        })
                    });
                }
            });
    }

    onsubmit = (event: any) => {
        event.preventDefault();
        if (this.state.selectedBank === 0) {
            return false;
        }

        let urlParams = getAllUrlParams(this.context.search);

        this.setState({ isSendingData: true });

        fetch(
            IDEAL_TRANSACTIONREQUEST_URL +
                '?transactionGuid=' +
                urlParams.transactionGuid +
                '&issuerId=' +
                this.state.selectedBank,
            {
                method: 'post',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            }
        )
            .then(response => {
                this.setState({ isSendingData: false });
                if (response.status >= 300) {
                    return { error: true, reply: response.json() };
                } else {
                    return response.json();
                }
            })
            .then(json => {
                if (!!(json as any).error) {
                    json.reply.then(reply => {
                        // Pass error-reply from server to error-popup
                        this.props.showErrorOnApiError(reply);
                    });

                    return;
                }

                location.href = (json as any).Url;
            });
        return false;
    }

    formatAmountAsCurrencyInEuros(amount: number) {
        if ((amount as any) === undefined) {
            return '';
        }
        return (
            '€ ' +
            amount
                .toFixed(2)
                .replace('.', ',')
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        );
    }

    render() {
        if (this.state.doRedirect && this.state.redirectUrl != '') {
            return <Redirect to={this.state.redirectUrl} />;
        }

        if (this.state.isLoading) {
            return <></>;
        }

        if (this.state.hasError) {
            return <></>;
        }

        if (this.state.isTransactionNotFound) {
            return (
                <>
                    <div className="mijn-fnv__ideal-payment-intro pb-5">
                        <h2>{this.props.title}</h2>
                        <div className="mijn-fnv__ideal-payment-intro-content">
                            {getResourceString("Form.Ideal.TransactionNotFoundError")}
                        </div>
                    </div>
                </>
            );
        }

        let intro = ReactHtmlParser(this.props.intro);

        return (
            <div className="mijn-fnv-form__content-block">
                <div className="mijn-fnv__ideal-payment-intro">
                    <h2>{this.props.title}</h2>
                    <div className="mijn-fnv__ideal-payment-intro-content">{intro}</div>
                </div>
                <div className="mijn-fnv__ideal-payment-details">
                    <p>{this.state.customerTransactionDescription}</p>
                    <p className="mijn-fnv__ideal-payment-amount">
                        {this.formatAmountAsCurrencyInEuros(this.state.totalAmount)}
                    </p>
                </div>
                <form className="form mijn-fnv-form__ideal-payment" onSubmit={this.onsubmit}>
                    <div className={'mijn-fnv-form__content-block mijn-fnv-form__ideal-block'}>
                        <div className={'mijn-fnv__ideal-logo-container'}>
                            <img
                                className={'mijn-fnv__ideal-logo'}
                                src="/assets/img/layout/iDEAL_512x512.png"
                            />
                        </div>
                        <label className="mijn-fnv__ideal-bank-label">
                            {this.props.bankSelectorLabel}
                        </label>
                        <Select
                            placeholder={this.props.selectBankPlaceholder}
                            options={this.state.issuerList}
                            styles={styles}
                            classNamePrefix="form-dropdown"
                            className="form-control form-dropdown__container"
                            onChange={(value: any) => {
                                this.setState({ selectedBank: value.value });
                            }}
                        />
                    </div>
                    <div className="mijn-fnv__ideal-payment-button-container">
                            {this.state.isSendingData && (
                                <span className="spinner spinner-border"></span>
                            )}
                            <button
                                className="btn btn-success mijn-fnv__ideal-payment-button"
                                disabled={this.state.isSendingData || this.state.selectedBank === 0}
                            >
                                {this.props.paymentButtonTitle}
                            </button>
                        </div>
                </form>
            </div>
        );
    }

    static contextType = MijnFNVPageContext;
    context!: React.ContextType<typeof MijnFNVPageContext>;
}

export const MijnFNVIdealBankSelector = connect(
    mapStateToProps,
    mapDispatchToProps
)(MijnFNVIdealBankSelectorContained);
